<div class="bg-card">
    <!-- <div class="flex justify-end mb-1">
    <mat-icon svgIcon="heroicons_outline:x-circle"
              matTooltip="Cerrar"
              class="close-button"
              mat-dialog-close
              style="cursor: pointer;">
    </mat-icon>
</div> -->
    <!-- Header -->
    <div
        class="relative flex flex-0 flex-col border-b px-4 py-4 sm:flex-row sm:items-center sm:justify-between md:px-6">
        <!-- Title -->
        <div class="text-2xl font-extrabold tracking-tight m-3">Cuentas</div>
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
            <!-- Search -->
            <!-- <mat-form-field class="fuse-mat-dense fuse-mat-rounded min-w-64" subscriptSizing="dynamic">
                <mat-icon class="icon-size-5" matPrefix svgIcon="heroicons_solid:magnifying-glass"></mat-icon>
                <input matInput placeholder="Buscar" autocomplete="off" (input)="applyFilter($event.target.value)" />
            </mat-form-field> -->
            <!-- Add button (only icon) -->
            <button mat-icon-button color="primary" (click)="openCreateModal()" matTooltip="Crear nuevo">
                <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
            </button>
            <!-- <mat-icon svgIcon="heroicons_outline:x-circle" matTooltip="Cerrar" class="close-button" mat-dialog-close
                style="cursor: pointer;">
            </mat-icon> -->
        </div>
    </div>

    <!-- Main Content (Table and Paginator) -->
    <div class="flex flex-auto overflow-hidden flex-col">
        <!-- Tabla -->
        <div class="container mt-0 flex-auto flex-col overflow-x-auto">
            <!-- Header -->
            <div class="sticky top-0 z-10 bg-gray-100 dark:bg-gray-900">
                <table class="min-w-500 overflow-y-visible mat-elevation-z" mat-table [dataSource]="dataSource" matSort
                    matSortDisableClear multiTemplateDataRows> <!-- (matSortChange)="changeSort($event)" -->

                    <!-- Número de Cuenta -->
                    <ng-container matColumnDef="accountNumber">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="pl-10 text-left">Número de Cuenta
                        </th>
                        <td mat-cell *matCellDef="let element" class="pl-10 text-left">{{ element.accountNumber }}</td>
                    </ng-container>

                    <!--Moneda-->
                    <ng-container matColumnDef="currency">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="pl-10 text-left">Moneda</th>
                        <td mat-cell *matCellDef="let element" class="pl-10 text-left">
                            <b class="f-10">{{ element?.currency[0]?.code }}</b> <br>
                            {{ element?.currency[0]?.name }}
                        </td>
                    </ng-container>

                    <!--Comisión-->
                    <ng-container matColumnDef="commission">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="pl-10 text-left">Comisión</th>
                        <td mat-cell *matCellDef="let element" class="pl-10 text-left">{{ element.commission }}</td>
                    </ng-container>

                    <!--Tipo-->
                    <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="pl-10 text-left">Tipo</th>
                        <td mat-cell *matCellDef="let element" class="pl-10 text-left">{{
                            getBankAccountTypeLabel(element?.type) }}</td>
                    </ng-container>

                    <!-- Acciones -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
                        <td mat-cell *matCellDef="let element" class="px-6 py-3 text-left">
                            <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #actionMenu="matMenu">
                                <button mat-menu-item (click)="openEditModal(element)">
                                    <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                                    <span>Editar</span>
                                </button>
                                <button mat-menu-item (click)="openAccountSaleOffice(element)">
                                    <mat-icon svgIcon="heroicons_outline:clipboard-document-list"></mat-icon>
                                    <span>Determinación de Cuentas</span>
                                </button>
                                <button mat-menu-item (click)="openDeleteDialog(element)">
                                    <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                                    <span>Eliminar</span>
                                </button>
                            </mat-menu>
                        </td>
                    </ng-container>

                    <!-- Header Row -->
                    <tr mat-header-row *matHeaderRowDef="displayedColumns" class="bg-gray-100 dark:bg-gray-900"></tr>

                    <!-- Fila principal -->
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="border-b"></tr>
                </table>
            </div>
            <div *ngIf="this.dataSource.data.length === 0" class="border-t p-8 text-center text-1xl sm:p-10">Lo
                sentimos, no hay registros para mostrar.
            </div>
        </div>

        <!-- Paginación debería asignar valor a this.pageSize-->
             <mat-dialog-actions class="modal-actions flex justify-start">
                <button mat-button mat-dialog-close class="align-left">Cerrar</button>
                </mat-dialog-actions>
        <!-- <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
            <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons
                [length]="totalItems" [pageSize]="pageSize"></mat-paginator>
        </div> -->
    </div>

    <!-- Modales -->
    <ng-template #addModal>
        <h2 mat-dialog-title class="text-lg font-bold mb-1">Crear Cuenta</h2>
        <mat-dialog-content class="modal-content">
            <form #createForm="ngForm">
                <div class="grid grid-cols-2 gap-4">
                    <mat-form-field appearance="fill" class="w-full">
                        <mat-label>Tipo</mat-label>
                        <mat-select [(ngModel)]="currentCreateBankAccount.type" name="type" required>
                            @for (type of typeBankAccountList; track type) {
                            <mat-option [value]="type">
                                {{ getBankAccountTypeLabel(type) }}
                            </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="fill" class="w-full">
                        <mat-label>Moneda</mat-label>
                        <mat-select [(ngModel)]="currentCreateBankAccount.currencyId" name="currencyId" required
                            multiple>
                            @for (currency of currencyFilterList; track currency) {
                            <mat-option [value]="currency._id">
                                {{ currency.name }}
                            </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="fill" class="w-full">
                        <mat-label>Tipo de Pago</mat-label>
                        <mat-select [(ngModel)]="currentCreateBankAccount.paymentTypeId" name="paymentTypeId" required
                            multiple>
                            @for (paymentType of paymentTypeFilterList; track paymentType) {
                            <mat-option [value]="paymentType._id">
                                {{ paymentType.name }}
                            </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="fill" class="w-full">
                        <mat-label>Número de Cuenta</mat-label>
                        <input matInput [(ngModel)]="currentCreateBankAccount.accountNumber" name="accountNumber"
                            required>
                    </mat-form-field>
                    <mat-form-field appearance="fill" class="w-full">
                        <mat-label>Comisión</mat-label>
                        <input matInput type="number" [(ngModel)]="currentCreateBankAccount.commission"
                            name="commission" required>
                    </mat-form-field>
                    <mat-form-field appearance="fill" class="w-full">
                        <mat-label>Retención</mat-label>
                        <input matInput type="number" [(ngModel)]="currentCreateBankAccount.taxRetainment"
                            name="taxRetainment" required>
                    </mat-form-field>
                    <div class="col-span-2">
                        <app-form-section title="Valores que se establecen a menos que se configure por oficina de venta" icon="settings" iconColor="purple">
                            <div class="grid grid-cols-2 gap-4">
                                <mat-form-field appearance="fill" class="w-full">
                                    <mat-label>Cuenta Contable</mat-label>
                                    <input matInput [(ngModel)]="currentCreateBankAccount.accountingAccount"
                                        name="accountingAccount" required>
                                </mat-form-field>
                                <mat-form-field appearance="fill" class="w-full">
                                    <mat-label>Clave Contable</mat-label>
                                    <input matInput [(ngModel)]="currentCreateBankAccount.accountingKey" name="accountingKey">
                                </mat-form-field>
                                <mat-form-field appearance="fill" class="w-full">
                                    <mat-label>Centro de Costo</mat-label>
                                    <input matInput [(ngModel)]="currentCreateBankAccount.costCenter" name="costCenter">
                                </mat-form-field>
                            </div>
                        </app-form-section>
                    </div>
                </div>
            </form>
        </mat-dialog-content>
        <mat-dialog-actions class="modal-actions flex justify-end">
            <button mat-button mat-dialog-close class="align-left">Cancelar</button>
            <button mat-raised-button color="primary" (click)="createBankAccount()"
                [disabled]="!createForm.valid">Guardar</button>
        </mat-dialog-actions>
    </ng-template>

    <!-- Modal Editar -->
    <ng-template #editModal>
        <h2 mat-dialog-title class="text-lg font-bold mb-1">Editar Cuenta</h2>
        <mat-dialog-content class="modal-content">
            <form #editForm="ngForm">
                <div class="grid grid-cols-2 gap-4">
                    <mat-form-field appearance="fill" class="w-full">
                        <mat-label>Tipo</mat-label>
                        <mat-select [(ngModel)]="currentUpdateBankAccount.type" name="type" required>
                            @for (type of typeBankAccountList; track type) {
                            <mat-option [value]="type">
                                {{ getBankAccountTypeLabel(type) }}
                            </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="fill" class="w-full">
                        <mat-label>Moneda</mat-label>
                        <mat-select [(ngModel)]="currentUpdateBankAccount.currencyId" name="currencyId" required
                            multiple>
                            @for (currency of currencyFilterList; track currency) {
                            <mat-option [value]="currency._id">
                                {{ currency.name }}
                            </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                 <mat-form-field appearance="fill" class="w-full">
                        <mat-label>Tipo de Pago</mat-label>
                        <mat-select [(ngModel)]="currentUpdateBankAccount.paymentTypeId" name="paymentTypeId" required
                            multiple>
                            @for (paymentType of paymentTypeFilterList; track paymentType) {
                            <mat-option [value]="paymentType._id">
                                {{ paymentType.name }}
                            </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="fill" class="w-full">
                        <mat-label>Número de Cuenta</mat-label>
                        <input matInput [(ngModel)]="currentUpdateBankAccount.accountNumber" name="accountNumber"
                            required>
                    </mat-form-field>
                    <mat-form-field appearance="fill" class="w-full">
                        <mat-label>Comisión</mat-label>
                        <input matInput type="number" [(ngModel)]="currentUpdateBankAccount.commission"
                            name="commission" required>
                    </mat-form-field>
                    <mat-form-field appearance="fill" class="w-full">
                        <mat-label>Retención</mat-label>
                        <input matInput type="number" [(ngModel)]="currentUpdateBankAccount.taxRetainment"
                            name="taxRetainment" required>
                    </mat-form-field>
                    <div class="col-span-2">
                        <app-form-section title="Valores que se establecen a menos que se configure por oficina de venta" icon="settings" iconColor="purple">
                            <div class="grid grid-cols-2 gap-4">
                                <mat-form-field appearance="fill" class="w-full">
                                    <mat-label>Cuenta Contable</mat-label>
                                    <input matInput [(ngModel)]="currentUpdateBankAccount.accountingAccount"
                                        name="accountingAccount" required>
                                </mat-form-field>
                                <mat-form-field appearance="fill" class="w-full">
                                    <mat-label>Clave Contable</mat-label>
                                    <input matInput [(ngModel)]="currentUpdateBankAccount.accountingKey" name="accountingKey">
                                </mat-form-field>
                                <mat-form-field appearance="fill" class="w-full">
                                    <mat-label>Centro de Costo</mat-label>
                                    <input matInput [(ngModel)]="currentUpdateBankAccount.costCenter" name="costCenter">
                                </mat-form-field>
                            </div>
                        </app-form-section>
                    </div>
                </div>
            </form>
        </mat-dialog-content>
        <mat-dialog-actions class="modal-actions flex justify-end">
            <button mat-button mat-dialog-close class="align-left">Cancelar</button>
            <button mat-raised-button color="primary" (click)="updateBank(currentUpdateBankAccount._id)"
                [disabled]="!editForm.valid">Guardar</button>
        </mat-dialog-actions>
    </ng-template>

    <ng-template #deleteDialog let-data>
        <div class="flex items-start space-x-2 mb-4">
            <div class="flex items-center">
                <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
                    style="font-size: 32px;"></mat-icon>
            </div>
            <div class="grid">
                <h2 mat-dialog-title class="text-lg font-bold mb-1">Confirmar eliminación</h2>
                <mat-dialog-content class="modal-content mt-0">
                    <p>¿Está seguro que desea eliminar el registro?</p>
                </mat-dialog-content>
            </div>
        </div>
        <mat-dialog-actions class="modal-actions flex justify-end">
            <button mat-button mat-dialog-close class="align-left">Conservar</button>
            <button mat-raised-button color="warn" [mat-dialog-close]="true">Eliminar</button>
        </mat-dialog-actions>
    </ng-template>
</div>